export default {
  unsaved_teacher_feedback: false,
  loading: true,
  currentDiscussion: {
    title: '',
    points_settings: {
      peer_rewards: [],
    },
    point_cap: 1,
    participations: [],
    polls: [],
    links: [],
    invites: [{ code: '111' }],
    queue: [],
    queue_history: [],
    turns_in_circle: [],
    live_log: [],
    users_present: [],
    guiding_questions: [],
    toggleable_resource_questions: [],
    toggleable_guiding_questions: [],
    audio_is_active: false,
    audio: {},
    genie_recap: {},
    transcriptions: [], 
    teacher_tapped_in_id: null,
    applause_turn: { applauderID: null, turnID: null, participationID: null },
    google_classroom_course_work_id: null,
    language: 'gb',
    
  },
  grades: {
    classSummary: {
      student_participations: [{}],
      users: [{}],
      total_turns: 0,
      all_turns: [],
      total_rewards_given_count: 0,
    },
    studentSummary: {
      automated_feedback: [],
      taken_suggestions: [],
      notes: { content: '', is_published: false },
      applause_count: 0,
      user_id: '',
      feedback_for_student: [],
      points_settings: {
        peer_rewards: [],
      },
      user: {
        id: null,
        name: '',
      },
      nudges: [],
    },
    loading: false,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/liveDiscussions/state.js